import React from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "../../../../shared/components/ui/icons/Icon";
import classes from "./MenuMobileNavItem.module.css";

const MenuMobileNavItem = ({ title, icon, to, onNavigate }) => {

    const location = useLocation();
    const isActive = location.pathname === to || location.pathname.startsWith(`${to}/`);

    const handleClick = () => {
        onNavigate?.();
    };

    return (
        <Link to={to} className={`${classes.NavItem} ${isActive ? classes.NavItemActive : ""}`} onClick={handleClick}>
            <span className={classes.NavIcon}>
                <Icon size="32.9px" name={icon} color="#6300FF" />
            </span>
            <span className={classes.NavLabel}>{title}</span>
        </Link>
    );
};

export default MenuMobileNavItem;
